module.exports = __webpack_public_path__ + "static/img/020_4.7320c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_4.jpg
// module id = qIo5
// module chunks = 1